module.exports = __webpack_public_path__ + "img/38888291ec72bfb1fbaffd3fcaec335.c4929b29.jpg";